import { combineReducers } from "redux";

import LoggedInUserReducer from "../reducers/User";
import AppConfigsReducer from "../reducers/AppConfigs";
import {
  AdminSelectedUserDetailsReducer,
  GetPatientFromMbiReducer,
  GetAuthPacketReducer,
  GetPortalUpdateReducer,
  MasterMfaPreferenceReducer,
  MasterPayerReducer,
  MasterNtuReasonReducer,
  MasterRoleReducer,
  MasterServiceProviderReducer,
  PatientInformationByIdReducer,
  PostAddPortalUpdateReducer,
  PostAddUserReducer,
  PostCheckEligibilityReducer,
  PostInformationReceivedReducer,
  PostNtuPatientReducer,
  ReferralAuthHistoryReducer,
  ReferralListReducer,
  ReferralSearchReducer,
  UpdateUserDetailsReducer,
  UserListReducer,
  UserSendMfaInfoReducer,
  UserVerifyMfaInfoReducer,
  MasterCareTypeReducer,
  MasterSendCommunicationAuthTypeReducer,
  MasterReferralSourceReducer,
  IcdCodeReducer,
  FaqsReducer,
  PostPriorAuthReducer,
  DocumentUploadReducer,
  SetDefaultReAuthValuesReducer,
  SlotsReducer,
  ReAuthReferralDataReducer,
  GetServiceProviderDetailsReducer,
  PostReAuthReducer,
  TrainingVideoReducer,
  GeneratedVideoUrlReducer,
  DeleteTrainingVideoReducer,
  PostIngestProcessReducer,
  ReferralManagementReducer,
  RegisterUserReducer,
  UserByClaimsReducer,
  MasterDocumentTypeReducer,
  MasterDocumentNoteReducer,
  ResetPasswordReducer,
  ResendRegistrationReducer,
  UserStatusReducer,
  PostSendPassReducer,
  ResetPassReducer,
  AddTrainingVideoReducer,
  EditTrainingVideoReducer,
  MasterDisciplineReducer,
  BenefitPlanUidReducer,
  ScorecardDetailsReducer,
  PostCreatePatientReducer,
  ExcelDownloadReducer,
  MasterFeatureAccessReducer,
  PostAdminAccessListReducer,
  PutAdminAccessListReducer,
  MasterServiceProviderDefaultReducer,
  UserPageTrackReducer,
  TabSessionStorage,
  EligibilityInformationReducer,
  MemberInfoReducer,
  NppesDetailsDataReducer,
  DiseaseType,
  IcdCodeType,
  TabSessionReAuthReducer,
  GetPhysicianDetailsReducer,
  DisciplineStatusReducer,
  MasterDischargeReasonReducer,
  PutNOMNCDocDetailsReducer,
  UpdateStartOfCareDateReducer,
  LogContractIdPBPDetailsReducer,
  GetSsoHpsClaimsStatusReducer,
  GetSAMLResponseReducer,
  PostNotificationReducer,
  PostNotificationListReducer,
  MasterNotificationTypeReducer,
  PutNotificationReducer,
  DeactivateNotificationsReducer,
  GetSsoHppClaimsStatusReducer,
} from "../reducers";
import CompareNPIDetailsReducer from "../reducers/GetCompareNPIDetails";
import DocumentReviewReducer from "../reducers/DocumentReview";
import DocumentDownload from "../reducers/DocumentDownload";
import IcdCodeForReAuthReducer from "../reducers/IcdCodeForReAuth";
import ScorecardBaselineTableReducer from "../reducers/GetScorecardBaselinetable";
import IsRetroDetailsReducer from "../reducers/GetIsRetroDetails";
import HeadersNotificationListReducer from "../reducers/HeadersNotificationListReducer";
import PutNotificationViewListReducer from "../reducers/PutNotificationViewList";
import DownloadDocumentOfNotificationReducer from "../reducers/DownloadDocumentOfNotification";
import UserLogoutReducer from "../reducers/UserLogout";
import GetRefreshTokenReducer from "../reducers/GetRefreshTokenReducer";
import MasterLanguageReducer from "../reducers/LanguageMaster";

const createRootReducer = combineReducers({
  loggedInUserState: LoggedInUserReducer,
  appConfigsState: AppConfigsReducer,
  masterMfaPreferenceState: MasterMfaPreferenceReducer,
  updateUserDetailsState: UpdateUserDetailsReducer,
  userSendMfaInfoState: UserSendMfaInfoReducer,
  userVerifyMfaInfoState: UserVerifyMfaInfoReducer,
  masterRoleState: MasterRoleReducer,
  masterServiceProviderState: MasterServiceProviderReducer,
  addUserState: PostAddUserReducer,
  userListState: UserListReducer,
  adminSelectedUserDetailsState: AdminSelectedUserDetailsReducer,
  addPortalUpdateState: PostAddPortalUpdateReducer,
  getPortalUpdateState: GetPortalUpdateReducer,
  referralListState: ReferralListReducer,
  referralSearchState: ReferralSearchReducer,
  referralAuthHistoryState: ReferralAuthHistoryReducer,
  ntuPatientState: PostNtuPatientReducer,
  masterNtuReasonState: MasterNtuReasonReducer,
  authPacketDownloadState: GetAuthPacketReducer,
  healthPlanState: MasterPayerReducer,
  checkEligibilityState: PostCheckEligibilityReducer,
  patientFromMbiState: GetPatientFromMbiReducer,
  informationState: PostInformationReceivedReducer,
  patientInformationByIdState: PatientInformationByIdReducer,
  frequentlyAskedQuestionState: FaqsReducer,
  masterCareTypeState: MasterCareTypeReducer,
  masterSendCommunicationAuthTypeState: MasterSendCommunicationAuthTypeReducer,
  masterReferralSourceState: MasterReferralSourceReducer,
  icdCodeState: IcdCodeReducer,
  priorAuthSubmitState: PostPriorAuthReducer,
  documentUploadState: DocumentUploadReducer,
  reAuthDefaultValueState: SetDefaultReAuthValuesReducer,
  slotsState: SlotsReducer,
  reAuthReferralDetailState: ReAuthReferralDataReducer,
  reAuthServiceProviderState: GetServiceProviderDetailsReducer,
  reAuthSubmitState: PostReAuthReducer,
  trainingVideoState: TrainingVideoReducer,
  generatedVideoUrlState: GeneratedVideoUrlReducer,
  deleteTrainingVideoState: DeleteTrainingVideoReducer,
  ingestProcessState: PostIngestProcessReducer,
  referralManagementState: ReferralManagementReducer,
  registerUserState: RegisterUserReducer,
  userByClaimsState: UserByClaimsReducer,
  addTrainingVideoState: AddTrainingVideoReducer,
  masterDocumentTypeState: MasterDocumentTypeReducer,
  masterDocumentNoteState: MasterDocumentNoteReducer,
  getResetPasswordState: ResetPasswordReducer,
  getResendRegistrationState: ResendRegistrationReducer,
  getActivateDeActivateUserState: UserStatusReducer,
  forgotLinkState: PostSendPassReducer,
  resetPassState: ResetPassReducer,
  editTrainingVideoState: EditTrainingVideoReducer,
  disciplineListState: MasterDisciplineReducer,
  benefitPlanUidState: BenefitPlanUidReducer,
  scorecardDetailsState: ScorecardDetailsReducer,
  createPatientState: PostCreatePatientReducer,
  compareNPIDetailsState: CompareNPIDetailsReducer,
  excelDownloadState: ExcelDownloadReducer,
  masterFeatureAccessState: MasterFeatureAccessReducer,
  adminAccessListState: PostAdminAccessListReducer,
  updateAgencyAccessState: PutAdminAccessListReducer,
  documentReviewState: DocumentReviewReducer,
  documentDownloadState: DocumentDownload,
  masterServiceProviderDefaultState: MasterServiceProviderDefaultReducer,
  userTrackPageState: UserPageTrackReducer,
  tabSessionStorageState: TabSessionStorage,
  eligibilityInformationState: EligibilityInformationReducer,
  memberInfoDataState: MemberInfoReducer,
  nppesDetailsDataState: NppesDetailsDataReducer,
  disaseTypeState: DiseaseType,
  icdCodeTypeState: IcdCodeType,
  tabSessionStorageReAuthState: TabSessionReAuthReducer,
  icdCodeForReAuthState: IcdCodeForReAuthReducer,
  physicianDetailsState: GetPhysicianDetailsReducer,
  disciplineStatusState: DisciplineStatusReducer,
  dischargeReasonState: MasterDischargeReasonReducer,
  noMncDetailsState: PutNOMNCDocDetailsReducer,
  updateStartOfCareDateState: UpdateStartOfCareDateReducer,
  logContractIdPBPDetailsState: LogContractIdPBPDetailsReducer,
  ssoHpsClaimsStatusUrlState: GetSsoHpsClaimsStatusReducer,
  scorecardBaselineTableState: ScorecardBaselineTableReducer,
  isRetroDetailsState: IsRetroDetailsReducer,
  samlResponseState: GetSAMLResponseReducer,
  notificationsState: PostNotificationReducer,
  notificationListState: PostNotificationListReducer,
  notificationTypeState: MasterNotificationTypeReducer,
  updateNotificationState: PutNotificationReducer,
  deactivateNotificationState: DeactivateNotificationsReducer,
  headerNotificationListState: HeadersNotificationListReducer,
  updateNotificationViewListState: PutNotificationViewListReducer,
  downloadDocumentOfNotificationState: DownloadDocumentOfNotificationReducer,
  userLogoutState: UserLogoutReducer,
  ssoHppClaimsStatusUrlState: GetSsoHppClaimsStatusReducer,
  refreshTokenResponseState: GetRefreshTokenReducer,
  masterLanguageState: MasterLanguageReducer,
});

export default createRootReducer;
